import { createApp } from "vue";
import App from "./App.vue";

import './assets/reset.css';

const app = createApp(App)
app.mount("#app");
